import * as Utility from '../shared/utility';
import { USER_CREATE, USER_UPDATE, USER_BY_ACCOUNT, USER_ADD_TO_ACCOUNT, EMPLOYER_ACCOUNT_USER, USER_UPDATE_PASSWORD, USER_REMOVE_FROM_ACCOUNT } from '../redux/serverEndpoints';
import { BaseItem } from './BaseItem';
export class User extends BaseItem {
    constructor(guid = null, email = null) {
        super();
        this.guid = guid;
        this.email = email;
        this.mobile_phone = null;
        this.first_name = null;
        this.last_name = null;
        this.user_type = UserType.Worker;
        this.is_verified = false;
        this.is_active = false;
        this.is_onboarded = false;
        this.is_profile_complete = false;
        this.share_code = null;
        this.is_saved = false;
        this._apiController = "user";
    }
    load(guid, onSuccess, onFailure = null, loadPublic = false) {
        //this.standardLoad(this, guid, loadPublic ? USER_PUBLIC(guid) : USER(guid), onSuccess, onFailure);
    }
    save(userInfo, onSuccess, onFailure = null) {
        if (Object.keys(userInfo).length > 0) {
            const endpoint = userInfo["guid"] ? USER_UPDATE : USER_CREATE;
            Utility.httpRequest(endpoint.url, endpoint.data, userInfo)
                .then((res) => {
                console.log('[User successfully saved]', res);
                this.is_saved = true;
                if (onSuccess !== null) {
                    onSuccess(res);
                }
            })
                .catch((error) => {
                var _a, _b;
                console.log('[User save error]', error);
                Utility.errorLog(error);
                if (onFailure !== null) {
                    onFailure((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details);
                }
                Utility.notifyError(error.response.data.details);
                // return;
            });
        }
        else {
            Utility.notifyError('ERROR: The user reqBody is empty');
        }
    }
    getUsersByAccount(accountGuid, onSuccess) {
        let endpoint = USER_BY_ACCOUNT(accountGuid);
        Utility.httpRequest(endpoint.url, endpoint.data, null)
            .then((resp) => {
            const users = resp.data;
            const finalUsers = [];
            // console.log("Successful user load", resp, users);
            users.forEach(u => {
                let user = new User();
                Object.assign(user, u);
                user.doesExist(true);
                finalUsers.push(user);
            });
            // console.log("[FINAL USERS]", finalUsers);
            if (onSuccess !== null) {
                onSuccess(finalUsers);
            }
        })
            .catch(err => {
            var _a, _b, _c;
            console.error("Users load error:", (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : err);
            Utility.errorLog(err);
        });
    }
    /*getUsersByLocation(locationGuid: String, onSuccess: (user:User[]) => any){
        let endpoint = USER_BY_LOCATION(locationGuid);

        Utility.httpRequest(endpoint.url, endpoint.data, null)
            .then((resp) => {
                const users = resp.data;
                const finalUsers: User[] = [];
                // console.log("Successful user load", resp, users);

                users.forEach(u => {
                    let user: User = new User();
                    Object.assign(user, u);
                    user.doesExist(true);
                    finalUsers.push(user);
                })
                // console.log("[FINAL USERS]", finalUsers);
                if(onSuccess !== null) {
                    onSuccess(finalUsers);
                }
            })
            .catch(err => {
                console.error("Users load error:", err?.response?.data?.details ?? err);
                Utility.errorLog(err);
            });
    }*/
    static getAccountUser(accountGuid, userGuid, onSuccess) {
        let endpoint = EMPLOYER_ACCOUNT_USER(accountGuid, userGuid);
        Utility.httpRequest(endpoint.url, endpoint.data, null)
            .then((resp) => {
            const users = resp.data;
            // console.log("Successful account user load", resp, users);
            if (onSuccess !== null) {
                onSuccess(users);
            }
        })
            .catch(err => {
            var _a, _b, _c;
            console.error("Account user load error:", (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : err);
            Utility.errorLog(err);
        });
    }
    /*static getLocationUser(locationGuid: String, userGuid: String, onSuccess: (user:User[]) => any){
        let endpoint = EMPLOYER_LOCATION_USER(locationGuid, userGuid);
        
        Utility.httpRequest(endpoint.url, endpoint.data, null)
            .then((resp) => {
                const users = resp.data;
                // console.log("Successful location user load", resp, users);
                if(onSuccess !== null) {
                    onSuccess(users);
                }
            })
            .catch(err => {
                console.error("Location user load error:", err?.response?.data?.details ?? err);
                Utility.errorLog(err);
            });
    }*/
    static updatePassword(user, onSuccess, onFailure) {
        let endpoint = USER_UPDATE_PASSWORD;
        const data = {
            userID: user.id,
            password: user.password,
            email: user.email,
            confirm: "ONCEEMAILISSETUPIWILLSUPPLYTHIS"
        };
        if (user.password != user.confirmPassword) {
            Utility.errorLog("Passwords do not match");
            return;
        }
        Utility.httpRequest(endpoint.url, endpoint.data, data)
            .then((resp) => {
            var _a, _b;
            const success = resp.data.Data;
            if (success == true) {
                if (onSuccess !== null) {
                    onSuccess();
                }
            }
            else {
                Utility.errorLog("Error updating password");
                if (onFailure != null)
                    onFailure((_b = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.Message) !== null && _b !== void 0 ? _b : "Error updating password");
            }
        })
            .catch(err => {
            var _a, _b, _c;
            console.error("Users load error:", (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : err);
            Utility.errorLog(err);
        });
    }
    static addUserToAccount(accountGuid, userDetails, onSuccess, onFailure) {
        //console.log('[ADD USER TO XCOMP][USER GUID]', userGuid, '[ACCOUNT GUID]', accountGuid);        
        const endpoint = USER_ADD_TO_ACCOUNT;
        const reqBody = {
            "accountID": accountGuid,
            "email": userDetails.email,
            "first-name": userDetails.first_name,
            "last-name": userDetails.last_name,
            "password": userDetails.password,
        };
        Utility.httpRequest(endpoint.url, endpoint.data, reqBody)
            .then((res) => {
            var _a, _b;
            console.log('[USER][ADD USER TO ACCOUNT][RESPONSE]', res);
            if (res.data.Data == true) {
                if (onSuccess !== null) {
                    onSuccess();
                }
            }
            else {
                Utility.errorLog("Error adding user");
                if (onFailure != null)
                    onFailure((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.Message) !== null && _b !== void 0 ? _b : "Error adding user");
            }
        })
            .catch(err => {
            Utility.errorLog(err);
        });
    }
    /*static addUserToLocation(locationGuid: String, userPermissions: SaveUserPermission, onSuccess: () => any) {
        const endpoint = USER_ADD_TO_LOCATION;
        const reqBody = {
            "location_guid": locationGuid,
            "email":  userPermissions.email,
            "is_admin": userPermissions.is_admin,
            "manage_jobs": userPermissions.manage_jobs,
            "manage_applicants": userPermissions.manage_applicants
        };
        if (!Utility.isEmpty(userPermissions.user_guid)) reqBody["user_guid"] = userPermissions.user_guid;
        
        Utility.httpRequest(endpoint.url, endpoint.data, reqBody)
            .then( () => {
                // console.log('[USER][ADD USER TO LOCATION][RESPONSE]', res);
                if(onSuccess != null) {
                    onSuccess();
                }
            })
            .catch(err => {
                Utility.errorLog(err);
            });
    }*/
    removeUserFromAccount(accountGuid, onSuccess) {
        const endpoint = USER_REMOVE_FROM_ACCOUNT;
        const reqBody = {
            "accountID": accountGuid,
            "user_guid": this.guid,
        };
        Utility.httpRequest(endpoint.url, endpoint.data, reqBody)
            .then(() => {
            if (onSuccess != null) {
                onSuccess();
            }
        })
            .catch(err => {
            Utility.errorLog(err);
        });
    }
}
class SaveUserPermission {
    constructor() {
        this.is_admin = false;
        this.manage_jobs = false;
        this.manage_applicants = false;
        this.email = null;
        this.user_guid = null;
    }
}
export var UserType;
(function (UserType) {
    UserType["Worker"] = "Worker";
    UserType["Employer"] = "Employer";
})(UserType || (UserType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["Any"] = "Any";
    UserRole["Owner"] = "Owner";
    UserRole["Employer"] = "Employer";
    UserRole["Worker"] = "Worker";
    UserRole["Admin"] = "Admin";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=User.js.map